module.exports = __webpack_public_path__ + "static/media/dr4-group.708f44a2.jpg";